import _ from 'lodash'
import React, { useEffect, useState } from 'react';
import { DateTime } from 'luxon'
import './Program.css'; // Import CSS file for styling
import ProgramSession from './ProgramSession';
import { DAYS_OF_WEEK_DISPLAY } from '../constants/constants';
import { getCoachProgramById } from '../api/programs';

const Program = ({ program, programId, onChange, onClose }) => {
  const [index, setIndex] = useState(0)
  const [displayedSessions, setDisplayedSessions] = useState([])
  const [stateProgram, setStateProgram] = useState(null)

  useEffect(() => {
    if (stateProgram) setDisplayedSessions(stateProgram.pastSessions.concat(stateProgram.upcomingSessions))
  }, [stateProgram])

  useEffect(() => {
    async function updateStateProgram(programId, propsProgram) {
      if (!stateProgram && programId) {
        const getByProgramResponse = await getCoachProgramById(programId)
        const program = getByProgramResponse.data
        setStateProgram(program)
        setDisplayedSessions(program.pastSessions.concat(program.upcomingSessions))
        setIndex(program.pastSessions.length)
      }
      if (!stateProgram && program) {
        setStateProgram(program)
      }
    }
    updateStateProgram(programId, program)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [programId, program])

  if (!stateProgram) return null

  const session = _.isEmpty(displayedSessions) ? null : displayedSessions[index]
  const startDateTime = DateTime.fromFormat(stateProgram.startDate, 'yyyy-MM-dd')
  const endDateTime = DateTime.fromFormat(stateProgram.endDate, 'yyyy-MM-dd')
  const startTimeDateTime = DateTime.fromFormat(stateProgram.startTime, 'H:mm')
  const endTimeDateTime = DateTime.fromFormat(stateProgram.endTime, 'H:mm')
  const normalStartTime = startTimeDateTime.toFormat('hh:mm a')
  const normalEndTime = endTimeDateTime.toFormat('hh:mm a')
  
  const handleForward = () => {
    setIndex(prevIndex => Math.min(displayedSessions.length - 1, prevIndex + 1))
    if (onChange) onChange()
  }

  const handleBack = () => {
    setIndex(prevIndex => Math.max(0, prevIndex - 1))
    if (onChange) onChange()
  }

  const handleSessionChange = (updatedSession) => {
    const updatedSessions = displayedSessions.map(s => 
      s.id === updatedSession.id ? updatedSession : s
    );
    setDisplayedSessions(updatedSessions);
    if (onChange) onChange();
  };

  const sessionDateTime = session ? DateTime.fromFormat(session.date, 'yyyy-MM-dd') : null

  return (
    <div className="program-container">
      {onClose && (
        <button className="close-button" onClick={onClose} aria-label="Close">
          ✕
        </button>
      )}

      <div className="program-header-navy">
        <h2 className="program-title-navy">{stateProgram.title}</h2>
        <div className="program-meta-navy">
          {startDateTime.toFormat('MMM dd')} - {endDateTime.toFormat('MMM dd')} • {DAYS_OF_WEEK_DISPLAY[JSON.stringify(stateProgram.daysOfWeek)]} {normalStartTime} - {normalEndTime}
        </div>
      </div>

      <div className="session-navigation">
        <button
          className="nav-button"
          onClick={handleBack}
          disabled={index === 0}
        >
          ←
        </button>
        <div className="session-counter">
          <div className="session-counter-main">Session {index + 1} of {displayedSessions.length}</div>
          {sessionDateTime && (
            <div className="session-counter-date">{sessionDateTime.toFormat('EEEE, MMM dd')}</div>
          )}
        </div>
        <button
          className="nav-button"
          onClick={handleForward}
          disabled={index === displayedSessions.length - 1}
        >
          →
        </button>
      </div>

      {session && (
        <ProgramSession
          session={session}
          onChange={handleSessionChange}
        />
      )}
    </div>
  )
}

export default Program